import { useTranslation } from 'react-i18next'
import { ProjectCardV2 } from './project-card-v2'
import type { TeamWithActions } from '@/shared/types'

interface InProgressSectionProps {
  teams: TeamWithActions[]
}

export function InProgressSection({ teams }: InProgressSectionProps) {
  const { t } = useTranslation()

  if (teams.length === 0) return null

  return (
    <section className="flex flex-col gap-4">
      {/* Section header */}
      <h2 className="text-lg font-semibold text-foreground">
        {t('dashboard.sections.inProgress', { count: teams.length })}
      </h2>

      {/* Cards grid */}
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 xl:grid-cols-3">
        {teams.map((team) => (
          <ProjectCardV2
            key={team.id}
            team={team}
            variant={team.active_project?.status === 'quoting' ? 'completed' : 'active'}
          />
        ))}
      </div>
    </section>
  )
}
